import React from 'react'
import { Viewer, Worker, SpecialZoomLevel } from '@react-pdf-viewer/core'
import '@react-pdf-viewer/core/lib/styles/index.css'
import { version as pdfjsVersion } from 'pdfjs-dist'
import AdminUserGuide from '../../assets/pdf/AdminUserGuide.pdf'
import TeamMemberUserGuide from '../../assets/pdf/TeamMemberUserGuide.pdf'
import { Box } from '@mui/system'

interface UserGuideProps {
  role: string
}

const UserGuide: React.FC<UserGuideProps> = ({ role = 'teamMember' }) => {
  return (
    <Worker workerUrl={`//unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}>
      <Box p={2} sx={{ width: '100%' }}>
        <div className='scrollable-content' style={{ height: 'auto', overflow: 'auto' }}>
          <Viewer
            fileUrl={role === 'admin' ? AdminUserGuide : TeamMemberUserGuide}
            defaultScale={SpecialZoomLevel.PageWidth}
          />
        </div>
      </Box>
    </Worker>
  )
}

export default UserGuide
